export default {
  CONTACT_US: 'Hubungi Kami',
  CONTACT_US_SUBTITLE:
    'Ralali siap membantu Anda mengembangkan bisnis dan mengatasi berbagai tantangan bisnis yang Anda hadapi.<br /> Tim Konsultan Bisnis kami akan segera menghubungi Anda.',
  COMPANY_INFORMATION: 'Informasi Perusahaan',
  FIND_US: 'Temukan Kami di Google Maps',
  POPULAR_PRODUCTS: 'Produk Populer',
  RECOMMENDATED_PRODUCTS: 'Rekomendasi Produk',
  RECOMMENDATED_SUPPLIERS: 'Rekomendasi Supplier',
}
